module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-movie__session-select",
    class: {
      active: _vm.active, 'btn-mask': true, disabled: !_vm.getStatus(_vm.session)
    },
    on: {
      "click": function($event) {
        _vm.clickCallback(_vm.session)
      }
    }
  }, [_c('div', {
    staticClass: "detail-movie__session-select-inner"
  }, [_c('div', {
    staticClass: "detail-movie__session-select-time"
  }, [_vm._v("\n      " + _vm._s(_vm.session && _vm.session.show_time && _vm.session.show_time.additional.no_zero_hour_24 ? _vm.session.show_time.additional.no_zero_hour_24 : '') + ":" + _vm._s(_vm.session && _vm.session.show_time && _vm.session.show_time.additional.minute ? _vm.session.show_time.additional.minute : '') + "\n    ")]), _vm._v(" "), _c('figure', {
    staticClass: "detail-movie__session-select-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.getExperienceIcon(),
      "alt": _vm.getExperienceAlt()
    }
  })])]), _vm._v(" "), (_vm.getStatusString(_vm.session)) ? [_c('div', {
    staticClass: "detail-movie__session-select-status",
    class: [_vm.getStatusString(_vm.session) == 'Sold Out' ? 'state--full' : '']
  }, [_vm._v("\n      " + _vm._s(_vm.getStatusString(_vm.session)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62724ed4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/detailSessionCard.vue
// module id = 545
// module chunks = 0